
import historyChat from "./helper/historyChat";
import cookieFinder from "./cookieFinder";

class chatHistory {
    constructor() { 
        this.init();
    }

 async init() {   
          try {  
                cookieFinder(anyBacken.historyCookie) && await historyChat(); 
              } catch (error) {
            return false;
          } 
        }  
    }

    export default chatHistory;